import React, { Component } from 'react'
import Switch from "react-switch";
import axios from 'axios';
import { CREATE_AGENT } from '../../config/rest_endpoints';
import { getUser } from '../../actions/session';
import { Notifications } from '../common/notification';
import Select from 'react-select';

export default class CreateAgent extends Component {
    constructor(props) {
        super(props)
        this.state = {  
            User:getUser(),
            name:'',
            email:'',
            phone:'',
            address:'',
            commission:'',
            selectType:[
                {label:"Profit",value:"profit"},
                {label:"Gross",value:"gross"}
            ],
            selectedType: {label:"Profit",value:"profit"},
            selectFreq:[
                {label:"Monthly",value:"monthly"},
                {label:"Weekly",value:"weekly"}
            ],
            selectedFreq: {label:"Monthly",value:"monthly"},
            switched:true,
            isLoad:false
        }

        this.onHandleChange = this.onHandleChange.bind(this)
        this.createAgent = this.createAgent.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.handleSelectFreq = this.handleSelectFreq.bind(this)
        this.handleSelectType = this.handleSelectType.bind(this)
    }

    onHandleChange(e) {
        this.setState({[e.target.name]:e.target.value})
    }

    handleSelectType(selectedType) {
        this.setState({ selectedType});
        console.log(`selectedType:`, selectedType);
        
    };

    handleSelectFreq(selectedFreq) {
        this.setState({ selectedFreq });
        console.log(`selectedFreq:`, selectedFreq);
    };

    toggleSwitch() {
        this.setState({switched:!this.state.switched})
    }

    createAgent() {
        const {name,email,phone,address,commission,freq,switched,User,selectedType,selectedFreq} = this.state
        var payload = {
            "name": name,
            "email": email,
            "phone": parseInt(phone),
            "address":address,
            "commission": `${commission}`,
            "type": selectedType.value,
            "frequency": selectedFreq.value,
            "active": switched
        }
        this.setState({isLoad:true})
        console.log('payload',payload)
        var headers = { "Authorization": "Bearer " + User.token };
        axios.post(`${CREATE_AGENT}`,payload,{headers}).then(res=>{
            if(res) {
                console.log(res)
                Notifications.notify('Agent Created',"Created",'success')
                this.props.close();
                this.props.listing();
                this.setState({isLoad:false})
            }
        }).catch(err=>{
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            Notifications.notify(msessage, "Failed", "error")
            this.setState({isLoad:false})
        })
        
    }

    render() {
        const {name,email,phone,address,commission,freq,switched,type,selectedFreq,selectFreq,selectedType,selectType} = this.state

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        return (
            <div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Name</label>
                            <input type="text" className="form-control" name="name" value={name} onChange={this.onHandleChange} placeholder="Enter name" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Email</label>
                            <input type="email" className="form-control" name="email" value={email} onChange={this.onHandleChange} placeholder="Enter email" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Phone</label>
                            <input type="number" className="form-control" name="phone" value={phone} onChange={this.onHandleChange} placeholder="Enter phone" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Address</label>
                            <input type="text" className="form-control" name="address" value={address} onChange={this.onHandleChange} placeholder="Enter address" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Commission</label>
                            <input type="text" className="form-control" name="commission" value={commission} onChange={this.onHandleChange} placeholder="Enter commission" />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Type</label>
                            <Select
                                value={selectedType}
                                onChange={this.handleSelectType}
                                options={selectType}
                                placeholder="Select Type"
                            />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label style={labelStyle}>Frequency</label>
                            <Select
                                value={selectedFreq}
                                onChange={this.handleSelectFreq}
                                options={selectFreq}
                                placeholder="Select Frequency"
                            />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="form-group" style={{marginTop:'4px'}}>
                            <label style={labelStyle}>Status</label>
                            <div style={{marginTop:'4px'}}>
                                <Switch onChange={this.toggleSwitch} checked={switched} onColor="#10B981" offColor="#CBD5E1" height={22} width={44} handleDiameter={18} />
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'16px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        disabled={this.state.isLoad}
                        onClick={this.createAgent}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: this.state.isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: this.state.isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Create Agent
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : "icon-user-plus"} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}
